export default "__VITE_ASSET__66ff77d9__"